import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CoreValuCard, CoreValuContainer } from "./styles";
import { Border } from "../../EventDetails/styles";
import { fetchApi } from "../../../utils/methods";
import { GetCompanyCoreValues, UpdateCompanyCoreValueStatus } from "../../../redux/constants/apiConstants";
import LazyImage from "../../common/LazyImage/LazyImage";
import { ImageUrl } from "../../../utils/constants";
import { RecognitionEyeIcon, RecognitionPencilIcon, RecognitionArchiveIcon, RecognitionWarningIcon, ArchiveIcon, RecognitionTickIcon } from "../../../utils/icons";
import CoreValuePopup from "../corevalues/CoreValuePopup";
import { ManagerIconContainer } from "../../Manager/styles";
import SkeletonLoder from "../../common/skeletonLoder";
import CommonModal from "../../common/CommonModal/CommonModal";
import { toast } from "react-toastify";

export const ActiveLibraryTab = ({ history, companyInfo,activeTab ,activeTabV}) => {


  const [coreValues, setCoreValues] = useState([]);
  const [selectedCoreValue, setSelectedCoreValue] = useState();
  const [showCoreValuePopup, setShowCoreValuePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [selectedCoreValues, setSelectedCoreValues] = useState([]);

  useEffect(() => {
    fetchCompanyCoreValues(companyInfo.id)
  }, []);




  const fetchCompanyCoreValues = async (companyId) => {

    setLoading(true);

    const res = await fetchApi(GetCompanyCoreValues + "/" + companyId, "GET");
   
    if (res.status === "success") {
      setCoreValues(res.data);
      setLoading(false);
    }

  }

  const updateCoreValueData = async (payload) => {
    try {
      const res = await fetchApi(UpdateCompanyCoreValueStatus + "/" + companyInfo.id, "PUT", payload);
      if (res.data.message) {
        toast.error(res?.data?.message);
      } else {
        toast.success(res?.data[0]);
        fetchCompanyCoreValues(companyInfo.id)
      }
    } catch (error) {
      // toast.error(error)
    }
  }

  const SelectCoreValue = (id) => {

    const allCoreValues = [...selectedCoreValues];
    if (allCoreValues.includes(id)) {
      let index = allCoreValues.findIndex((item) => item === id);
      if (index > -1) {
        allCoreValues.splice(index, 1);
      }
    } else {
      allCoreValues.push(id);
    }

    setSelectedCoreValues(allCoreValues);
  };

  const ShowCoreValueDetails = (coreValue) => {
    setShowCoreValuePopup(true);
    setSelectedCoreValue(coreValue)
  }



  const handleCancel = () => {
    setShowModal(false);
  };

  const handleConfirm = () => {
    const postobject = {
      core_value_ids: selectedCoreValues,
      type: "archive"
    }
    setShowModal(false);
    updateCoreValueData(postobject)
  };

  const handleArchiveButton = () => {
    if (selectedCoreValues?.length === 0) {
      toast.error("Please select atleast one core value to archive")
    } else {
      setShowModal(true);
    }
  }


  return (
    <>
      {loading ? <SkeletonLoder width={"1246px"} height={"500px"} /> : <> <CoreValuContainer>
        <div className="top-bar-container">
          <div id="core-values-header" className="header">Core Values</div>
          {isArchive ? (
            <div className="archive-active">
              <div className="archive-btn" onClick={() => handleArchiveButton()} /* onClick={()=>setShowModal(true)}*/>
                <span className="archive-btn-icon">
                  {RecognitionArchiveIcon()}
                </span>
                Yes, Archive
              </div>
              <div
                className="cancel-archive"
                onClick={() => setIsArchive(false)}
              >
                Cancel
              </div>
            </div>
          ) : (
            <div id="archieveSection" className="archive" onClick={() => setIsArchive(true)}>
              Archive
            </div>
          )}
        </div>
        <Border style={{ border: "1px solid #EFEFEF", margin: "20px 0px" }} />

        {coreValues?.length > 0 ? <div className="core-values">
          {coreValues.map((coreValue, index) => (
            <>
              <div id={`activeCoreValues${index}`} className="border-btm">
                {/* <CoreValuCard key={index}>
                  <div className="core-value-row">
                    <div className="col-one">
                      <div className="icon" style={{background:coreValue?.recognition_color_value}}>
                        <LazyImage style={{width:"24px"}} src={ImageUrl + "/" + coreValue?.image}/>
                      </div>
                      <div className="title">{coreValue?.core_value}</div>
                    </div>
                    <div className="action">
                      <div className="eye-icon" onClick={()=>ShowCoreValueDetails(coreValue)}><ManagerIconContainer> {RecognitionEyeIcon("#F37A65")}</ManagerIconContainer></div>
                      <div className="pencil-icon" onClick={()=>history.push({pathname:`/company/recognition/core-value/edit`, state:{title:coreValue.core_value, image:coreValue?.image, description:coreValue?.description, points:coreValue?.point, color:coreValue?.recognition_color_value, id: coreValue?.id}})}><ManagerIconContainer>{RecognitionPencilIcon()}</ManagerIconContainer></div>
                    </div>
                  </div>
                </CoreValuCard> */}
                <CoreValuCard
                  key={index}
                  selected={
                    selectedCoreValues.includes(coreValue.id) ? true : false
                  }
                >
                  <div className="core-value-row">
                    <div className="col-one">
                      <div
                        className="icon"
                        style={{ background: coreValue?.recognition_color_value }}
                      >
                        {coreValue?.white_icon ? <LazyImage
                          style={{ width: "24px" }}
                          src={ImageUrl + "/" + coreValue?.white_icon}
                        /> :null}
                      </div>
                      <div className="title">{coreValue?.core_value}</div>
                    </div>
                    <div className="action">
                      {isArchive ? (
                        <ManagerIconContainer>
                          <div
                            className="archive-action"
                            onClick={() => SelectCoreValue(coreValue.id)}
                          >
                            {selectedCoreValues.includes(coreValue.id)
                              ? RecognitionTickIcon()
                              : null}
                          </div>
                        </ManagerIconContainer>
                      ) : (
                        <>
                          <div id="eye-icon"className="eye-icon" onClick={() => ShowCoreValueDetails(coreValue)}><ManagerIconContainer> {RecognitionEyeIcon("#F37A65")}</ManagerIconContainer></div>
                          <div id="pencil-icon" className="pencil-icon" onClick={() => history.push({ pathname: `/company/recognition/core-value/edit`, state: { title: coreValue.core_value, image: coreValue?.image, description: coreValue?.description, points: coreValue?.point, color: coreValue?.recognition_color_value, id: coreValue?.id, core_value_id:coreValue?.core_value_id, white_icon : coreValue.white_icon,activeTab: activeTab, activeTabV:activeTabV } })}><ManagerIconContainer>{RecognitionPencilIcon()}</ManagerIconContainer></div>
                        </>
                      )}
                      {/* <div className="pencil-icon">{RecognitionPencilIcon()}</div> */}
                    </div>
                  </div>
                </CoreValuCard>
              </div>
            </>
          ))}

        </div>: <div className="no-data">There are No Core Values to archieve</div> }

      </CoreValuContainer>
      {showCoreValuePopup && (
        <CoreValuePopup
          showModal={showCoreValuePopup}
          detailInitiative={selectedCoreValue}
          onClose={() => setShowCoreValuePopup(false)}
          companyId={companyInfo?.id}
        />
      )}
      {showModal && <CommonModal
        show={showModal}
        icon={RecognitionWarningIcon("#B1AA56")}
        title="Archive Core Values"
        description="Are you sure you want to archive these core value?"
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        cancelText="Cancel"
        confirmButtonText="Yes, Archive"
        buttonIcon={ArchiveIcon()}
        modalHeight="184px"
        confirmButtonWidth="138px"
      />}
      </>}
    </>

  );
};

ActiveLibraryTab.propTypes = {
  history: PropTypes.object.isRequired,
  companyInfo: PropTypes.object.isRequired,
  activeTab: PropTypes.number.isRequired,
  activeTabV: PropTypes.string.isRequired,
};
